import { GLOBAL_GROUP_DATA_ATTRIBUTE, GLOBAL_PARTIAL_DATA_ATTRIBUTE
// @ts-expect-error Untyped module
} from 'InpageEditorUI/lib/inpage/utils';
// @ts-expect-error not typed
import { tellParentAboutSentryMessageInIframe } from 'ContentEditorUI/components/lameErrorHandling';
const GLOBAL_GROUP_DATA_SELECTOR = `[${GLOBAL_GROUP_DATA_ATTRIBUTE}]`;
const GLOBAL_PARTIAL_DATA_SELECTOR = `[${GLOBAL_PARTIAL_DATA_ATTRIBUTE}]`;
const SCRIPT_TAG = 'script';
const STYLE_TAG = 'style';
const IFRAME_TAG = 'iframe';
const FORM_TAG = 'form';
const INPUT_TAG = 'input';
const BUTTON_TAG = 'button';
const LABEL_TAG = 'label';
const SELECT_TAG = 'select';
const IMAGE_TAG = 'img';
const META_TAG = 'meta';
const TITLE_TAG = 'title';
const removeAllElementsFromNodeList = nodeList => {
  for (let i = 0; i < nodeList.length; i++) {
    const element = nodeList[i];
    if (element && element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
};
const getElementCopyOfSelector = editorSelector => {
  const originalElement = document.querySelector(editorSelector);
  let nodeCopy = originalElement && originalElement.cloneNode(true);
  if (!nodeCopy) {
    tellParentAboutSentryMessageInIframe(`\`fetchHTMLTextFromDocument\` couldn't find the editor with \`editorSelector\`: ${editorSelector}`, {
      editorSelector
    });
    // Return the body so the whole thing doesn't break
    const body = nodeCopy = document.querySelector('body');
    if (!body) {
      throw new Error('Well this is too much. Wheres the body?');
    }
    nodeCopy = body.cloneNode(true);
  }
  const docFragment = new DocumentFragment();
  docFragment.append(nodeCopy);
  const elementCopy = docFragment.firstElementChild;
  return elementCopy;
};
const removeExtraSpacingFromStrings = textString => {
  // Remove the extra spaces
  const stringWithoutExtraSpaces = textString.replace(/[\s]{2,}/g, ' ');
  return stringWithoutExtraSpaces;
};
export const fetchHTMLTextFromDocument = (editorSelector, extraSelectorsToIgnore = []) => {
  const copyOfInpageEditor = getElementCopyOfSelector(editorSelector); // Add selectors to ignore below)
  [GLOBAL_GROUP_DATA_SELECTOR, GLOBAL_PARTIAL_DATA_SELECTOR, ...extraSelectorsToIgnore].forEach(selector => {
    removeAllElementsFromNodeList(copyOfInpageEditor.querySelectorAll(selector));
  });
  // TagName selectors
  [SCRIPT_TAG, STYLE_TAG, IFRAME_TAG, FORM_TAG, INPUT_TAG, BUTTON_TAG, LABEL_TAG, SELECT_TAG, IMAGE_TAG, META_TAG, TITLE_TAG].forEach(tagName => removeAllElementsFromNodeList(copyOfInpageEditor.querySelectorAll(tagName)));
  const editorText = removeExtraSpacingFromStrings(copyOfInpageEditor.innerText);
  if (!editorText) {
    tellParentAboutSentryMessageInIframe(`\`fetchHTMLTextFromDocument\` didn't work with the editor selector: ${editorSelector}`, {
      editorSelector,
      documentString: document.body.innerHTML
    });
    return '';
  }
  return editorText.trim();
};